export const TITLE = `יתרונות המשכנתא המאחדת של WeCheck`

export const PARAGRAPH = `ללקיחת משכנתא מאחדת של Wecheck וביצוע איחוד הלוואות יש מספר יתרונות:`

export const CTA_TITLE = `למה אתם מחכים?`